import SubscriptionType from "./subscriptionType";

export default class Subscription {
  public idSubscription: number = 0;
  public subscriptionType: SubscriptionType = SubscriptionType.None;
  public canSeeAccounts: boolean = false;
  public canCreateAccounts: boolean = false;
  public canCreateServiceProviders: boolean = false;
  public canCreateWorkOrders: boolean = false;
}
